import React from 'react';

import { useTranslation } from 'react-i18next';

import FormInputSelect from '../FormInputSelect';

export default function RenderDropdownCreatable(props) {
  const { input, ...rest } = props;
  const { t } = useTranslation();

  return (
    <FormInputSelect
      creatable
      isClearable
      {...input}
      {...rest}
      placeholder={t('forms.selectCreate')}
    />
  );
}
